var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('i',{staticClass:"fas fa-code"}),_vm._v(" Example Vue Component\n    ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_vm._v("I'm an example Vue component!")])])
}]

export { render, staticRenderFns }